import React, {ReactElement} from "react";
import {ReactComponent as TheBottleLogo} from "components/Icons/logo.svg";
import { FormattedMessage } from "react-intl";

export interface FooterProps {
    degu: boolean
}

export function Footer(props: FooterProps): ReactElement | null {
    return (
        <div className="absolute left-0 bottom-0 text-[9px] mb-5 px-10 w-full">
            <div className="w-full flex justify-between">
                <span>
                    <FormattedMessage
                        id={props.degu ? 'editor.format.footerTextDegu' : 'editor.format.footerText'}
                        values={{
                            br: <br />
                        }}
                    />
                </span>
                <TheBottleLogo style={{height: '32px', maxWidth: '67px'}}/>
            </div>
        </div>
    );
}
